import { useMutation } from '@tanstack/react-query';

import { shareDemandInformation } from '../../common/api/clients/demand.api';

export const useShareDemandWithVessel = () => {
    return useMutation({ mutationFn: shareDemandInformation });
};
